import { connectedStore } from '../../store';
import setSettings from '../actions/set-settings';
import messages from '../../utils/messages';
import constants from '../constants';
import replaceCallbackInterruptions from '../utils/replace-callback-interruptions';

const setupMessages = () => {
  if (window === window.parent) {
    return;
  }

  messages.listen(window, (e) => {
    const { event, data } = e;

    if (event === constants.EVENT_TYPE_SET_SETTINGS) {
      const store = connectedStore.get();
      const settingsInjectedCallback = replaceCallbackInterruptions(data);
      store.dispatch(setSettings(settingsInjectedCallback));
    }
  });
};

export default setupMessages;
